<script setup lang="ts">
	import type { ApiDeliveriesResult } from '~/types';

	const route = useRoute();
	const baseUrl = useRuntimeConfig().public.NUXT_PUBLIC_SITE_URL;

	const priceResult = ref<ApiDeliveriesResult>();
	const pageTitle = 'Авиа доставка и консолидация грузов из Китая в Россию';
	const pageDescription =
		'Авиаперевозка сборных грузов один из самых быстрых и надёжных способов доставки. Оказываем сервис "под ключ": выкуп и забор груза у поставщика, хранение на складе, страхование груза, полное таможенное сопровождение. Мы гарантируем индивидуальный подход к каждому. Доставляем по всей России от двери до двери, так же возможен самовывоз.';

	useSeoMeta({
		title: pageTitle,
		description: pageDescription,
		ogTitle: pageTitle,
		ogDescription: pageDescription,
		ogImage: baseUrl + '/images/og-image.png',
		ogImageHeight: '630',
		ogImageWidth: '1200',
		ogUrl: baseUrl + '/',
		ogType: 'website',
		ogSiteName: pageTitle + '| АПП',
		ogLocale: 'ru_RU',
		twitterCard: 'summary_large_image',
		twitterTitle: pageTitle,
		twitterDescription: pageDescription,
		twitterImage: baseUrl + '/images/og-image.png',
	});

	const hideCalc = computed(() => route?.query?.withoutacalc === 'true');
</script>

<template>
	<div class="main-page__container">
		<SectionHero />
		<SectionCost v-if="hideCalc" />
		<SectionCalculatorForm v-if="!hideCalc" @calc-result="priceResult = $event" />
		<SectionAbout />
		<SectionWorkStages />
		<SectionConsultationForm />
		<SectionProblemSolving />
		<SectionAlternative :other-price="priceResult" />
		<SectionContact />
	</div>
</template>

<style lang="scss" scoped>
	.main-page__container {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 60px;
	}

	@media (min-width: 1240px) {
		.main-page__container {
			gap: 100px;
		}
	}
</style>
